var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-showcase-process-step section-space--pb_30"},[_c('div',{staticClass:"container"},[_c('LoginScreen'),_c('ShowcaseAdvancedFeatures'),_c('CreativeAppDisplay')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }